<template>
  <div class="live_top" @click="handleToDetail">
    <div class="top_tip" :style="'background-image:url('+liveinfo.poster+')'">
      <div class="mask">
        <div class="mask_top">
          <Status :status="liveinfo.livestate"></Status>
          <div class="people_times">
            <img src="../assets/images/icon-play.png"/>
            <span>{{liveinfo.pv|| 0}}人围观&nbsp;&nbsp; {{liveinfo.create_at}}</span>
          </div>
        </div>

        <!-- 根据直播状态不同展示不同的样式 -->
        <div v-if="liveinfo.livestate == '1'" class="mask_center">
          <div v-if="liveinfo.start_time != ''" class="have_time">
            <h2 class="yu_title">距开始直播</h2>
            <CountDown :startTime="liveinfo.start_time" @onEmit="handleCountDownEnd"/>
            <div class="line"></div>
            <p class="yu_time">直播开始时间：{{liveinfo.start_time}}</p>
          </div>
          <div v-else class="no_time">精彩直播即将开始</div>
        </div>
        <!-- <div v-else class="play_btn">
          <img src="../assets/images/play.png"/>
        </div> -->
      </div>
    </div>
    <!-- <img :src="liveinfo.poster" class="poster" /> -->
    <h3 class="title">{{liveinfo.title}}</h3>
  </div>
</template>

<script>
import Status from "./Status";
import CountDown from "./CountDown";
export default {
  props: {
    liveinfo: {
      type: Object
    }
  },
  data() {
    return {};
  },
  components: {
    Status,
    CountDown
  },
  methods: {
    /**
     * 倒计时结束
     */
    handleCountDownEnd() {
      this.$emit('onEmit')
    },
    handleToDetail() {
      window.location.href = this.liveinfo.share.url;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.live_top {
  margin-bottom: .45rem;
}
.title {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 .3rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: .32rem;
  color: #333;
  font-weight: normal;
}
.top_tip {
  width: 100%;
  height: 4.23rem;
  margin-bottom: .25rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.mask {
  box-sizing: border-box;
  padding: .24rem .3rem;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.mask_top {
  display: flex;
  justify-content: space-between;
}
.people_times {
  display: flex;
  align-items: center;
}
.people_times img {
  width: .3rem;
  height: .3rem;
}
.people_times span {
  font-size: .26rem;
  color: #fff;
}

.mask_center {
  margin-top: .5rem;
}
.yu_title {
  margin-bottom: .2rem;
  font-size: .36rem;
  color: #fff;
  font-weight: normal;
}
.line{
  margin-top: .2rem;
  width: 2rem;
  height: 2px;
  background-color: #fff;
}
.yu_time {
  margin-top: .28rem;
  font-size: .28rem;
  color: #fff;
}
.no_time{
  text-align: center;
  font-size: .36rem;
  color: #fff;
  margin-top: 1.5rem;
}
.have_time {
  margin-top: .5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.play_btn{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.play_btn>img {
  width: .96rem;
  height: .96rem;
}
</style>
